<div :class="$style.container">
  <fou-container :id="$vId(this, 'stepper')" cols="12" padded spacing>
    <template #header>
      <ul v-if="steps.length > 0" :class="$style.progressbar">
        <li
          v-for="step, key in steps"
          :key="key"
          :style="{'width': dynamicStepperWidth}"
          :class="[{[$style.active]: step.completed}, $style.spacing]"
        >
          <span :class="[{[$style.boldActive]: step.completed}]"
            >{{step.title}}</span
          >
        </li>
      </ul>
    </template>
    <template #content>
      <div>
        <keep-alive v-if="keepAlive">
          <component
            :is="steps[activeStep].component"
            :stepIdx="steps[activeStep].idx"
            :step3DataForStep2="siblingStepData"
          ></component>
        </keep-alive>
      </div>
    </template>
  </fou-container>
</div>
